import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Page from "./containers/Page/Page";
import Header from "./components/Header/Header";
import WelcomeModal from "./components/WelcomeModal/WelcomeModal";
import ChooseModelModal from "./components/ChooseModelModal/ChooseModelModal";
import { handleListChange, changeConfig, changeNameAndConfigForRecommended, saveCurrentState } from "./utils/listChanging";
import { checkAllRequiredElements } from "./utils/elementsChecking";
import {
  handleClearLocalStorage,
  handleRestoreFromLocalStorage,
  isLocalStorageEmpty,
  handleGenerate,
  handleImport,
  handleImportPredefinedTemplate,
  retrieveSettingsFromLocalStorage,
} from "./utils/localStorageHandling";
import InformativeModal from "./components/InformativeModal/InformativeModal";
import NewElementModal from "./components/NewElementModal/NewElementModal";
import Options from "./containers/Options/Options";
import { getEmptyCreatorLists, getPathToTypeList } from "./utils/listBodyUtils";
import saveSettingsToLocalStorage from "./utils/settingsChanging";
import { changeTheme } from "./utils/themeChanger";
import CurrentSvgSprite from "./components/CurrentSvgSprite/CurrentSvgSprite";
import NotificationContainer from "./containers/NotificationContainer/NotificationContainer";
import { defaultTemplateName, defaultThemeName, defaultMaxPrevSteps } from "./config/defaults";
import Navbar from "./containers/Navbar/Navbar";
import Preview from "./containers/Preview/Preview";
import Sidebar from "./containers/Sidebar/Sidebar";
import MobileNotAvailableWarning from "./components/MobileNotAvailableWarning/MobileNotAvailableWarning";
import {
  setLanguage,
  getTranslation,
  getCurrentLang,
} from "./assets/creator/translations";
import NewProjectModal from "./components/NewProjectModal/NewProjectModal";
import ChooseNewTemplateModal from "./components/ChooseNewTemplateModal/ChooseNewTemplateModal";
import ImportXmlPromptModal from "./components/ImportXmlPromptModal/ImportXmlPromptModal";
import jsondata from "./assets/elements.json";
import { getThemeSettings } from "./assets/creator/themes";
import TemplatesMenuModal from "./components/TemplatesMenuModal/TemplatesMenuModal";
import GenerateTemplateModal from "./components/GenerateTemplateModal/GenerateTemplateModal";
import MainLayoutContainer from "./containers/MainLayoutContainer/MainLayoutContainer";
import ImportTemplateModal from './components/ImportTemplateModal/ImportTemplateModal';
import { checkIsRefresh, checkLanguageFromAddress, checkAddressOptions, linksGenerator } from "./utils/welcomeModalsUtils";

class App extends Component {
  initialAppState = () => {
    const storedThemeName = localStorage.getItem("onlineCreatorB2B-currentThemeName");
    let themeSettings;
    if (storedThemeName) {
      themeSettings = getThemeSettings(storedThemeName.replace(/"/g, ""));
    } else {
      themeSettings = getThemeSettings(defaultThemeName);
    }
    
    return {
      ...getEmptyCreatorLists(),
      clickedElementType: null,
      isPreviewOn: false,
      isMobileOn: false,
      areOptionsOpen: false,
      colorSettings: Object.assign(
        themeSettings,
        require("./assets/settings").default
      ),
      templateSettings: require("./assets/creator/templateSettings").default,
      templateName: defaultTemplateName,
      isStyleMenuOpen: false,
      currentThemeName: defaultThemeName,
      recTypeCurrent: {},
      promotionalBannerTypeCurrent: 1,
      manufacturersSliderTypeCurrent: {},
      brandsSliderTypeCurrent: {},
      isNewProjectModalOpen: false,
      isChooseNewTemplateModalOpen: false,
      isWelcomeModalOpen: false,
      isChooseModelModalOpen: false,
      isTemplateMenuModalOpen: false,
      isGenerateTemplateModalOpen: false,
      isCheckRequiredEnabled: false,
      isInformativeModalVisible: false,
      elementInOptions: null,
      selectedTemplate: null,
      isTemplateSelected: false,
      showFixedElements: true,
      isImportTemplateModalOpen: false,
      showSwitchButton: false,
      lang: checkLanguageFromAddress() || getCurrentLang(),
      prevSteps: this.initPrevStepsState(defaultMaxPrevSteps),
      nextSteps: [{ typeOfChange: 0, value: null }],
      disablePrev: true,
      disableForward: true,
      addressOptions: {},
      isRefresh: false,
      isNewElementModalOpened: false,
      listOfNewElementsOpened: this.getListOfNewElementsOpened(),
    };
  };
  
  initPrevStepsState = (steps) => {
    const prevSteps = [];
    for (let i=0; i<steps; i++) {
      prevSteps.push({typeOfChange: 0, value: null});
    }
    return prevSteps;
  };

  getListOfNewElementsOpened = () => {
    const stored = localStorage.getItem('listOfNewElementsOpened');
    if (stored != null) {
      return stored.split(',');
    }
    return [];
  };

  prevChange = () => {
    this.setState((prevState) => {
    const prevChange = prevState.prevSteps[0];
    let nextChange = {};
    
    if (prevChange !== null && prevChange.value && prevChange.value !== null) {
      switch (prevChange.typeOfChange) {
        case 1:
          nextChange = {typeOfChange: 1, value: {typeData: prevState.currentThemeName, counter: {...this.counter}}};
          changeTheme.call(this, prevChange.value.typeData, true);
          break;
        case 2:
          nextChange = {typeOfChange: 2, value: {typeData: prevState.templateName, counter: {...this.counter}}};
          this.setTemplateName(prevChange.value.typeData, true);
          break;
        case 3:
          nextChange = {typeOfChange: 3, value: {typeData: prevState.colorSettings, counter: {...this.counter}}};
          this.updateSettings(prevChange.value.typeData, true);
          break;
        case 4:
          nextChange = {typeOfChange: 4, value: {typeData: [prevState.header, prevState.column], counter: {...this.counter}}};
          saveCurrentState.call(this, 'header', prevChange.value.typeData[0], '', true);
          saveCurrentState.call(this, 'column', prevChange.value.typeData[1], '', true);
          break;
        case 5:
          nextChange = {typeOfChange: 5, value: {typeData: prevState.mainBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'mainBody', prevChange.value.typeData, '', true);
          break;
        case 6:
          nextChange = {typeOfChange: 6, value: {typeData: prevState.footer, counter: {...this.counter}}};
          saveCurrentState.call(this, 'footer', prevChange.value.typeData, '', true);
          break;
        case 7:
          nextChange = {typeOfChange: 7, value: {typeData: prevState.cartBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'cartBody', prevChange.value.typeData, '', true);
          break;
        case 8:
          nextChange = {typeOfChange: 8, value: {typeData: prevState.productListBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'productListBody', prevChange.value.typeData, '', true);
          break;
        case 10: {
          const currentSettings = { ...prevState.templateSettings };
          const templateSettings = require('./assets/creator/templateSettings').default;
          nextChange = {typeOfChange: 10, value: {typeData: currentSettings, counter: {...this.counter}}};
          for (const property in templateSettings) {
            templateSettings[property] = prevChange.value.typeData[property];
          }
          this.updateTemplateSettings(templateSettings);
          break;
        }
        case 11:
          nextChange = {typeOfChange: 11, value: {typeData: [prevState.mainBody, prevState.productListBody, prevState.cartBody], counter: {...this.counter}}};
          saveCurrentState.call(this, ["mainBody", "productListBody", "cartBody"], prevChange.value.typeData, '', true, true);
          break;
        default:
          break;
      }

        const changesPrev = [...prevState.prevSteps];
        const changesForward = [...prevState.nextSteps];
        
        changesForward.unshift(nextChange);
        changesPrev.push({typeOfChange: 0, value: null});

        this.counter = {...prevChange.value.counter};

        const disablePrev = !(changesPrev[0] !== null && changesPrev[0].typeOfChange !== 0 && changesPrev[0].value !== null);

        return {
          prevSteps: changesPrev,
          nextSteps: changesForward,
          disablePrev: disablePrev,
          disableForward: false
        };
      }
      
      return null;
    });
  }

  forwardChange = () => {
    this.setState((prevState) => {
      const nextChange = prevState.nextSteps[0];
      let prevChange = {};
      
      if (nextChange === null || !nextChange.value) {
        return null;
      }
      
      switch (nextChange.typeOfChange) {
        case 1:
          prevChange = {typeOfChange: 1, value: {typeData: prevState.currentThemeName, counter: {...this.counter}}};
          changeTheme.call(this, nextChange.value.typeData, true);
          break;
        case 2:
          prevChange = {typeOfChange: 2, value: {typeData: prevState.template, counter: {...this.counter}}};
          this.setTemplateName(nextChange.value.typeData, true);
          break;
        case 3:
          prevChange = {typeOfChange: 3, value: {typeData: prevState.colorSettings, counter: {...this.counter}}};
          this.updateSettings(nextChange.value.typeData, true);
          break;
        case 4:
          prevChange = {typeOfChange: 4, value: {typeData: [prevState.header, prevState.column], counter: {...this.counter}}};
          saveCurrentState.call(this, 'header', nextChange.value.typeData[0], '', true);
          saveCurrentState.call(this, 'column', nextChange.value.typeData[1], '', true);
          break;
        case 5:
          prevChange = {typeOfChange: 5, value: {typeData: prevState.mainBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'mainBody', nextChange.value.typeData, '', true);
          break;
        case 6:
          prevChange = {typeOfChange: 6, value: {typeData: prevState.footer, counter: {...this.counter}}};
          saveCurrentState.call(this, 'footer', nextChange.value.typeData, '', true);
          break;
        case 7:
          prevChange = {typeOfChange: 7, value: {typeData: prevState.cartBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'cartBody', nextChange.value.typeData, '', true);
          break;
        case 8:
          prevChange = {typeOfChange: 8, value: {typeData: prevState.productListBody, counter: {...this.counter}}};
          saveCurrentState.call(this, 'productListBody', nextChange.value.typeData, '', true);
          break;
        case 10: {
          const currentSettings = { ...prevState.templateSettings };
          const templateSettings = require('./assets/creator/templateSettings').default;
          prevChange = {typeOfChange: 10, value: {typeData: currentSettings, counter: {...this.counter}}};
          for (const property in templateSettings) {
            templateSettings[property] = nextChange.value.typeData[property];
          }
          this.updateTemplateSettings(templateSettings);
          break;
        }
        case 11:
          prevChange = {typeOfChange: 11, value: {typeData: [prevState.mainBody, prevState.productListBody, prevState.cartBody], counter: {...this.counter}}};
          saveCurrentState.call(this, ["mainBody", "productListBody", "cartBody"], nextChange.value.typeData, '', true, true);
          break;
        default:
          break;
      }
      
      const changesPrev = [...prevState.prevSteps];
      const changesForward = [...prevState.nextSteps];

      changesPrev.unshift(prevChange);
      changesPrev.pop();

      for (let i=0; i<=changesForward.length - 1; i++) {
        if (i !== changesForward.length - 1 && changesForward[i+1] !== null) {
          changesForward[i] = changesForward[i+1];
          continue;
        }
        changesForward.pop();
      }

      this.counter = {...nextChange.value.counter};
      
      const disableForward = !(changesForward[0] !== null && changesForward[0].value);

      return {
        prevSteps: changesPrev,
        nextSteps: changesForward,
        disableForward: disableForward,
        disablePrev: false
      };
    });
  }
  updateChangesArray = (newValue, type = 0) => {
    /**
      * types:
      * 1 - themeName
      * 2 - templateName
      * 3 - colorSettings (fonts, icons, NOT colors)
      * 4 - header and column
      * 5 - mainBody
      * 6 - footer
      * 7 - cartBody
      * 8 - productListBody
      * 10 - settings (options)
      * 11 - definedSites (mainBody, productListBody, cartBody - SEQUENCE IS VERY IMPORTANT!!)
      * -------------------------------------
      * newValue takes object {typeData, counter}
    */

    if (type !== 0 && newValue !== undefined) {
      this.setState((prevState) => {
        const currentSettings = [...prevState.prevSteps];

        const lastUsedSettings = {
          typeOfChange: type,
          value: newValue,
        };

        currentSettings.unshift(lastUsedSettings);
        currentSettings.pop();

        const disablePrev = !(currentSettings[0] && currentSettings[0].typeOfChange !== 0 && currentSettings[0].value !== null);

        return {
          prevSteps: currentSettings,
          nextSteps: [{ typeOfChange: 0, value: null }],
          disablePrev: disablePrev,
          disableForward: true
        };
      });
    }
  }

  setCounterInitialState = () => {
    this.counter = {
      banner: 1,
      bannerList: 1,
      //default "global fallback"
      recommended: 1,
      "main-rec": 1,
      "productList-rec": 1,
      "product-rec": 1,
      promotionalBanner: 1
    };
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.initialAppState(),
      //on app start, get the language
      lang: checkLanguageFromAddress() || getCurrentLang(),
      //on app start, we want to render the modals
      isWelcomeModalOpen: true,
      isChooseModelModalOpen: false,
      isInformativeModalVisible: true,
      loading: this.props.isInIframe,
    };
    this.missingTypes = [];
    this.prefix = "onlineCreatorB2B-";
    this.dragStarted = false;
    this.setCounterInitialState();
    this.notifications = React.createRef();
    this.pathToTypeList = getPathToTypeList();
    this.pageBodiesMissingRequiredElements = {};
    this.sidebarRef = React.createRef();
    this.navbarRef = React.createRef();
    this.optionsRef = React.createRef();
    document.title = getTranslation("PageTitle");
  }

  bodyIsMissingRequiredElements = (listBody) =>
    !!this.pageBodiesMissingRequiredElements[listBody];
  checkPageBodiesForMissingElements = (start, end) =>
    this.state.isCheckRequiredEnabled && //we don't care about checking it when page doesn't display missing elements, so it's always false then
    start < end && // may yield in undefined behavior, so we return false
    this.pathToTypeList.slice(start, end).findIndex(
      //get part of the list that is either before or after the page (depending on args provided)
      (k) => this.bodyIsMissingRequiredElements(k.listName) //find body listName and check if it's missing elements
    ) !== -1; // assert that any list matching the criterion was found

  newProject = () => {
    handleClearLocalStorage.call(this);
    this.setCounterInitialState();
    this.setState(this.initialAppState);
  };

  reloadPage = () => {
    localStorage.setItem('isRefresh', 'true');
    window.location.reload();
  };

  onLangChange = (newLang) => {
    setLanguage(newLang);
    document.title = getTranslation("PageTitle");
    this.setState({ lang: newLang });
  };

  onRecTypeChange = (newRecType, listName) => {
    if (!listName) {
      return;
    }
    this.setState((prevState) => {
      const newRecTypeCurrent = { ...prevState.recTypeCurrent };
      newRecTypeCurrent[listName] = newRecType;
      return { recTypeCurrent: newRecTypeCurrent };
    });
  };

  onPromotionalBannerTypeChange = (newPromotionalBannerType, listName) => {
    if (!listName) {
      return;
    }
    
    this.setState((prevState) => {
      const newPromotionalBannerTypeCurrent = {
        ...prevState.promotionalBannerTypeCurrent,
      };
      newPromotionalBannerTypeCurrent[listName] = newPromotionalBannerType;
      
      return {
        promotionalBannerTypeCurrent: newPromotionalBannerTypeCurrent,
      };
    });
  };

  onManufacturersSliderTypeChange = (newManufacurersType, listName) => {
    if (!listName) {
      return;
    }
    this.setState((prevState) => {
      const newManufacurersTypeCurrent = {
        ...prevState.manufacturersSliderTypeCurrent,
      };
      newManufacurersTypeCurrent[listName] = newManufacurersType;
      
      return {
        manufacturersSliderTypeCurrent: newManufacurersTypeCurrent,
      };
    });
  };

  onBrandsSliderTypeChange = (newBrandsType, listName) => {
    if (!listName) {
      return;
    }
    this.setState((prevState) => {
      const newBrandsTypeCurrent = { ...prevState.brandsSliderTypeCurrent };
      newBrandsTypeCurrent[listName] = newBrandsType;
      return { brandsSliderTypeCurrent: newBrandsTypeCurrent };
    });
  };

  Navbar = () => (
    <Navbar
      ref={this.navbarRef}
      getNavBarWrapper={this.getNavBarWrapper}
      onNewProjectClick={this.reloadPage}
      onGenerate={handleGenerate.bind(this)}
      onImport={handleImport.bind(this)}
      missingTypes={this.missingTypes}
      onOpenImportTemplateModal={this.handleOpenImportTemplateModal}
    />
  );

  Sidebar = () => (
    <Sidebar
      ref={this.sidebarRef}
      onStyleMenuCloseTrigger={() => this.setState({ isStyleMenuOpen: false })}
      onStyleMenuOpenTrigger={() => this.setState({ isStyleMenuOpen: true })}
      getSidebarTemplateMenu={this.getSidebarTemplateMenu}
      getSideBarFooter={this.getSideBarFooter}
      colorSource={this.getColor}
      onColorSelect={this.setColor}
      onIconStyleSelect={this.setIconStyle}
      onCartIconStyleSelect={this.setCartIconStyle}
      onSpinnerIconStyleSelect={this.setSpinnerIconStyle}
      styleSettings={this.state.colorSettings}
      currentThemeName={this.state.currentThemeName}
      onFontSelect={this.setFont}
      onThemeSelect={changeTheme.bind(this)}
      onSelectColor={this.onSelectColor}
      onGenerate={handleGenerate.bind(this)}
      onImport={handleImport.bind(this)}
      missingTypes={this.missingTypes}
      onSettingsSave={this.onSettingsConfirm}
      onSettingsRevert={this.onSettingsRevert}
      onLangChange={this.onLangChange}
      currentLang={this.state.lang}
      showFixedElements={this.state.showFixedElements}
      toggleShowFixedElements={this.handleToggleShowFixedElements}
      pushNotification={this.pushNotification}
    />
  );

  
onSelectColor = (themeName) => {
  this.setState({ currentThemeName: themeName });
}

  setTemplateName = (name, stepsChange = false) => {
    if (!name) {
      name = defaultTemplateName;
    }

    if (stepsChange !== true) {
      this.updateChangesArray({typeData: this.state.templateName, counter: this.counter}, 2);
    }

    this.setState({ templateName: name });
    localStorage.setItem(this.prefix + "templateName", name);
    return true;
  };

  pushNotification = (type, message) =>
    this.notifications.current &&
    this.notifications.current.pushNotification({
      type: type,
      message: message,
    });

  setIconStyle = (iconStyle) =>
    this.updateSettings({ ...this.state.colorSettings, iconStyle: iconStyle });
  setCartIconStyle = (cartIconStyle) =>
    this.updateSettings({
      ...this.state.colorSettings,
      cartIconStyle: cartIconStyle
    });
  setSpinnerIconStyle = (spinnerIconStyle) =>
    this.updateSettings({
      ...this.state.colorSettings,
      spinnerIconStyle: spinnerIconStyle
    });
  setFont = (fontName) =>
    this.updateSettings({ ...this.state.colorSettings, fontFamily: fontName });
  getColor = (colorName) => this.state.colorSettings[colorName];
  setColor = (colorName, colorValue) => {
    const newSettings = { ...this.state.colorSettings };
    newSettings[colorName] = colorValue;

    this.updateSettings(newSettings, true);
  };

  updateSettings = (newSettings, stepsChange = false) => {
    if (stepsChange !== true) {
      if (JSON.stringify(newSettings) !== JSON.stringify(this.state.colorSettings)) {
        this.updateChangesArray({typeData: this.state.colorSettings, counter: this.counter}, 3);
      }
    }

    this.setState({ colorSettings: newSettings });
    
    saveSettingsToLocalStorage.call(
      this,
      newSettings,
      this.state.currentThemeName
    );
  }
  onSettingsRevert = () => retrieveSettingsFromLocalStorage.call(this);
  handleSaveSettings = (newSettings) => {
  
    this.updateSettings(newSettings);
    this.onSettingsConfirm(newSettings);
  };
  onSettingsConfirm = (newSettings) => {
 
    saveSettingsToLocalStorage.call(
      this,
      newSettings,
      this.state.currentThemeName
    );
    this.pushNotification("success", "Ntf_SettingsSavedSuccessfully");
  };

  updateTemplateSettings = (newSettings) => {
    this.setState({ templateSettings: newSettings });
 
    saveSettingsToLocalStorage.call(
      this,
      newSettings,
      this.state.currentThemeName
    );
  }

  getElement = (listName, i) => this.state[listName][i];
  handleElemTypeChange = (type, isHighlighted = false) => {
    this.sidebarRef.current.fixScrolling(!!type);
    this.setState({ clickedElementType: type });
    if(isHighlighted) {
      setTimeout(() => {
        const elementToHighlight = document.querySelectorAll('.element-type--active');
        if (elementToHighlight) {
          elementToHighlight[0].classList.add('element-type--highlightedWithModal');
          elementToHighlight[0].querySelectorAll('.showWhenHighlighted')[0].classList.remove('hidden');
        }
      });
    }
  };
  //opens options for item
  handleOptionsOpen = (element) => {
    this.setState({ areOptionsOpen: true, elementInOptions: element });
    this.optionsRef.current.saveInitialSettings();
  }
  updateChangesOption = () => {
    const currentSettings = { ...this.state.templateSettings };
    this.updateChangesArray({typeData: currentSettings, counter: this.counter}, 10);
  }

  handleOptionsClose = () => {
    this.setState({ areOptionsOpen: false, elementInOptions: null });
    localStorage.removeItem('tempSettings');
  }

  handleOptionsCloseWithRestore = () => {
    this.optionsRef.current.restoreInitialSettings();
    this.setState({ areOptionsOpen: false, elementInOptions: null });
  }

  handleDragStart = (dragStarted) => {
    this.dragStarted = dragStarted;
  };
  isDragStarted = () => this.dragStarted;

  handleInformativeModal = () =>
    this.setState({ isInformativeModalVisible: false});
  togglePreview = () => {
    this.setState((prevState) => ({ isPreviewOn: !prevState.isPreviewOn }));
    if (this.state.isPreviewOn === true && this.state.isMobileOn === true) {
      this.toggleMobilePreview();
    }
  }
  toggleMobilePreview = () =>
    this.setState((prevState) => ({ isMobileOn: !prevState.isMobileOn }));

  handleNewElementModal = () => {
    this.setState({ isNewElementModalOpened: false });
    const elementHighlighted = document.querySelectorAll('.element-type--highlightedWithModal');
    if (elementHighlighted[0]) {
        elementHighlighted[0].querySelectorAll('.showWhenHighlighted')[0].classList.add('hidden');
        elementHighlighted[0].classList.remove('element-type--highlightedWithModal');
    }
  }
  
  showNewElementModal = (type) => {
    this.setState({isNewElementModalOpened: true});

    const currentOpenedNewElements = this.state.listOfNewElementsOpened;
    let isElementExists = false;

    currentOpenedNewElements.forEach(function(item) {
      if (item === type) {
        isElementExists = true;
        return;
      }
    });

    if (!isElementExists) {
      currentOpenedNewElements.push(type);
      this.setState({listOfNewElementsOpened: currentOpenedNewElements});
    }

    this.setState({newElementTypeToShow: type});
    localStorage.setItem('listOfNewElementsOpened', this.state.listOfNewElementsOpened);
  }

  //handle for close button in welcome screen
  handleCloseWelcomeModal = () => this.setState({ isWelcomeModalOpen: false });

  //handle return button in choose model modal
  handleOpenWelcomeModal = () => this.setState({ isChooseModelModalOpen: false, isWelcomeModalOpen: true });

  //handle for close button in choose model modal
  handleCloseChooseModelModal = () => this.setState({ isChooseModelModalOpen: false });

  //handle for open and close button in templates menu modal
  handleOpenTemplatesMenu = () =>
    this.setState({
      isTemplateMenuModalOpen: true,
      isWelcomeModalOpen: false,
      isInformativeModalVisible: false,
      isChooseModelModalOpen: false,
    });

  handleLoadNewProjectTemplatesMenu = () => {
    this.newProject();
    this.afterSelectedTemplate();
  }

  handleOpenChooseNewTemplateModal = () => {
    this.setState({
      isChooseNewTemplateModalOpen: true,
      isTemplateMenuModalOpen: false
    });
  }

  handleReturnToChooseTemplate = () => {
    this.setState({
      isTemplateMenuModalOpen: true,
      isChooseNewTemplateModalOpen: false
    });
  }
  
  handleReturnToChooseSaleModel = () => {
    this.setState({
      isChooseModelModalOpen: true,
      isTemplateMenuModalOpen: false
    });
  }

  //handle close of templates menu modal and handle import of selected predefined template
  handleLoadProjectTemplatesMenu = (template, themeName) => {
    this.setState({
      selectedTemplate: template,
      currentThemeName: themeName,
      prevSteps: this.initPrevStepsState(defaultMaxPrevSteps),
      nextSteps: [{ typeOfChange: 0, value: null }],
      disablePrev: true,
      disableForward: true
    }, this.loadTemplate);
  };
  //handle open choose model modal
  handleOpenNextModal = () => {
    if (this.state.addressOptions.model && this.state.addressOptions.model === 'b2b') {
      this.setState({ isWelcomeModalOpen: false, isTemplateMenuModalOpen: true, isInformativeModalVisible: false });
    } else {
      this.setState({ isWelcomeModalOpen: false, isChooseModelModalOpen: true, isInformativeModalVisible: false });
    }
  }

  loadTemplate = () => {
    if (this.state.selectedTemplate) {
      this.newProject();
      handleImportPredefinedTemplate.call(this);
      this.afterSelectedTemplate();
    }
  }

  afterSelectedTemplate = () => this.setState({
    isTemplateMenuModalOpen: false,
    isInformativeModalVisible: true,
    isTemplateSelected: true,
  });

  openInstruction = () => {
    this.setState({
      isInformativeModalVisible: true,
      isTemplateSelected: true,

    });
  };

  handleTemplatesMenuStepBack = () => {
    this.setState({
      isTemplateMenuModalOpen: false,
      isInformativeModalVisible: false,
      isTemplateSelected: false,
      isWelcomeModalOpen: true,
    });
  };

  handleCloseGenerateTemplateModal = () =>
    this.setState({ isGenerateTemplateModalOpen: false });

  handleToggleShowFixedElements = () =>
    this.setState((prevState) => ({ showFixedElements: !prevState.showFixedElements }));

  handleToggleShowSwitchButton = () => {
    this.setState((prevState) => ({ showSwitchButton: !prevState.showSwitchButton }));
  }

  handleOpenImportTemplateModal = () => this.setState({isImportTemplateModalOpen: true});
  handleCloseImportTemplateModal = () => this.setState({isImportTemplateModalOpen: false});


  get pageCommonProps() {
    return {
      pageHeader: <this.Header />,
      pagePreview: <this.Preview />,
      type: this.state.clickedElementType,
      onElemTypeChange: this.handleElemTypeChange,
      onListChange: handleListChange.bind(this),
      pageBodyMissingCheck: this.bodyIsMissingRequiredElements,
      missingTypes: this.missingTypes,
      header: this.state.header,
      column: this.state.column,
      preview: this.state.preview,
      footer: this.state.footer,
      isPreviewOn: this.state.isPreviewOn,
      isCheckEnabled: this.state.isCheckRequiredEnabled,
      handleDragStart: this.handleDragStart,
      isDragStarted: this.isDragStarted,
      isMobileOn: this.state.isMobileOn,
      handleOptionsOpen: this.handleOptionsOpen,
      getElement: this.getElement,
      navbar: <this.Navbar />,
      navbarRef: this.navbarRef,
      sidebar: <this.Sidebar />,
      sidebarRef: this.sidebarRef,
      isStyleMenuOpen: this.state.isStyleMenuOpen,
      recommendedId: this.counter.recommended,
      onRecTypeChange: this.onRecTypeChange,
      onPromotionalBannerTypeChange: this.onPromotionalBannerTypeChange,
      onManufacturersSliderTypeChange: this.onManufacturersSliderTypeChange,
      onBrandsSliderTypeChange: this.onBrandsSliderTypeChange,
    };
  }

  //returns all possible routes
  getPages = () =>
    this.pathToTypeList.map((page, index) => (
      //route element that is displayed when visiting proper url, with corresponding Page component
      <Route
        key={page.listName}
        exact="true"
        path={page.path}
        element={
          <Page
            pageType={page.type}
            key={page.listName}
            bodyListName={page.listName}
            body={this.state[page.listName]}
            elementTypes={jsondata.elementTypes[page.type]}
            requiredTypes={jsondata.requiredTypes[page.listName]}
            previousPage={page.prevPagePath}
            previousPagesAreMissingTypes={this.checkPageBodiesForMissingElements(
              0,
              index
            )}
            nextPage={page.nextPagePath}
            nextPagesAreMissingTypes={this.checkPageBodiesForMissingElements(
              index + 1,
              this.pathToTypeList.length
            )}
            recTypeCurrent={this.state.recTypeCurrent[page.listName] || 2}
            showFixedElements={this.state.showFixedElements}
            toggleShowFixedElements={this.handleToggleShowFixedElements}
            showSwitchButton={this.state.showSwitchButton}
            toggleSwitchButton={this.handleToggleShowSwitchButton}
            {...this.pageCommonProps}
            isMobileOn={this.state.isMobileOn}
            handleMobilePreview={this.toggleMobilePreview}
            changeConfig={changeConfig.bind(this)}
            showNewElementModal={this.showNewElementModal}
            currentOpenedNewElements={this.state.listOfNewElementsOpened}
            promotionalBannerTypeCurrent={this.state.promotionalBannerTypeCurrent}
          />
        }
      />
    ));

  get shouldShowInstructionalModal() {
    return (
      !this.state.isWelcomeModalOpen &&
      this.state.isInformativeModalVisible &&
      (isLocalStorageEmpty.call(this) || this.state.isTemplateSelected)
    );
  }

  getModals = () => (
    <React.Fragment>
      {/*welcome modal is displayed when visiting the page*/}
      <WelcomeModal
        show={this.state.isWelcomeModalOpen}
        isMemoryEmpty={isLocalStorageEmpty.bind(this)}
        handleClear={handleClearLocalStorage.bind(this)}
        handleRestore={handleRestoreFromLocalStorage.bind(this)}
        handleOpenTemplatesMenu={this.handleOpenTemplatesMenu}
        handleClose={this.handleCloseWelcomeModal}
        handleOpenNextMenu={this.handleOpenNextModal}
      />

      {/*Choose sales model modal*/}
      <ChooseModelModal
        show={this.state.isChooseModelModalOpen}
        handleOpenWelcomeMenu={this.handleOpenWelcomeModal}
        handleOpenTemplatesMenu={this.handleOpenTemplatesMenu}
        lang={this.state.lang}
        isMemoryEmpty={isLocalStorageEmpty.bind(this)}
        isRefresh={this.state.isRefresh}
        handleRestore={handleRestoreFromLocalStorage.bind(this)}
        handleClose={this.handleCloseChooseModelModal}
      />

      {/*New element modal*/}
      <NewElementModal
        show={this.state.isNewElementModalOpened}
        type={this.state.newElementTypeToShow}
        handleClose={this.handleNewElementModal}
      />

      {/*display information about how to use this thing*/}
      <InformativeModal
        show={this.shouldShowInstructionalModal}
        isTemplateSelected={this.state.isTemplateSelected}
        handleClose={this.handleInformativeModal}
        // handleClear={handleClearLocalStorage.bind(this)}
        handleClear={this.handleClearLocalStorage}
        currentLang={this.state.lang}

      />
      {/* Prompt "new project, all changes will be lost" */}
      <NewProjectModal
        show={this.state.isNewProjectModalOpen}
        onConfirm={this.newProject}
        onCancel={() => this.setState({ isNewProjectModalOpen: false })}
      />
      { /* Choose new template - Saphire or Rubin */}
      {this.state.isChooseNewTemplateModalOpen && (
        <ChooseNewTemplateModal
          onInternalNew={this.handleLoadNewProjectTemplatesMenu}
          onReturn={this.handleReturnToChooseTemplate}
          lang={this.state.lang}
        />
      )}
      {/* Display predefined templates menu */}
      <TemplatesMenuModal
        show={this.state.isTemplateMenuModalOpen}
        onStepBack={this.handleTemplatesMenuStepBack}
        onLoadNew={this.handleOpenChooseNewTemplateModal}
        onLoadProject={this.handleLoadProjectTemplatesMenu}
        handleNewProject={this.newProject}
        handleClear={handleClearLocalStorage.bind(this)}
        onReturn={this.handleReturnToChooseSaleModel}
        lang={this.state.lang}
        />
      {/* Display information about generated template xml */}
      <GenerateTemplateModal
        show={this.state.isGenerateTemplateModalOpen}
        onClose={this.handleCloseGenerateTemplateModal}
      />

      {/* Display information before importing a template */}
      <ImportTemplateModal
          show={this.state.isImportTemplateModalOpen}
          handleClose={this.handleCloseImportTemplateModal}
          onImport={handleImport.bind(this)}
      />
    </React.Fragment>
  );

  Preview = () => (
    <Preview
      ref={this.PreviewRef}
      isPreviewOn={this.state.isPreviewOn}
      isDragStarted={this.isDragStarted}
      templateName={this.state.templateName}
      onTemplateNameChange={this.setTemplateName}
      getSidebarTemplateMenu={this.getSidebarTemplateMenu}
      //onNewProjectClick={() => this.setState({ isNewProjectModalOpen: true })}
      onNewProjectClick={this.reloadPage}
      handleMobilePreview={this.toggleMobilePreview}
      handleTogglePreview={this.togglePreview}
      showFixedElements={this.state.showFixedElements}
      toggleShowFixedElements={this.handleToggleShowFixedElements}
      showSwitchButton={this.state.showSwitchButton}
      toggleSwitchButton={this.handleToggleShowSwitchButton}
      isMobileOn={this.state.isMobileOn}
    />
  );

  Header = () => (
    <Header
      ref={this.HeaderRef}
      isPreviewOn={this.state.isPreviewOn}
      isDragStarted={this.isDragStarted}
      templateName={this.state.templateName}
      onTemplateNameChange={this.setTemplateName}
      getSidebarTemplateMenu={this.getSidebarTemplateMenu}
      //onNewProjectClick={() => this.setState({ isNewProjectModalOpen: true })}
      onNewProjectClick={this.reloadPage}
      handleTogglePreview={this.togglePreview}
      openInstruction={this.openInstruction}
      prevChange={this.prevChange}
      forwardChange={this.forwardChange}
      disablePrev={this.state.disablePrev}
      disableForward={this.state.disableForward}
    />
  );

  MainLayoutContainer = () => (
    <MainLayoutContainer
      onGenerate={handleGenerate.bind(this)}
      onImport={handleImport.bind(this)}
      missingTypes={this.missingTypes}
    />
  );

  rejectXmlImport = () => {
    this.setState({ xml: null });
  };
  loadTemplateXml = (xml) => {
    if (!xml) {
      //when xml is not provided as the argument, it's assumed that state contains xml and we want to import the xml from state
      handleImport.call(this, this.state.xml);
    } else {
      //otherwise, import what was provided in the argument
      handleImport.call(this, xml);
    }
    //after that, we discard xml from state and remove welcome modal
    this.setState({
      xml: null,
      isWelcomeModalOpen: false,
    });
  };

  iframeMessageListener = (e) => {
    this.setState({ loading: false, iframeOrigin: e.origin });
    if (!e.data.haveXml) { 
    return;
    }

    if (!isLocalStorageEmpty.call(this)) {
      this.setState({
        xml: e.data.xml,
      }); // save xml in state, may be imported after prompt
    } else {
      this.loadTemplateXml(e.data.xml); // when local storage is empty, we can load xml without thinking about it
    }
  };

  componentDidMount = async () => {
    if (window.location.search) {
      checkAddressOptions.call(this);
    } else {
      if (checkIsRefresh.call(this) || isLocalStorageEmpty.call(this)) {
        this.setState({ isWelcomeModalOpen: false, isChooseModelModalOpen: true, isInformativeModalVisible: false });
      }
    }

    if (!this.props.isInIframe) { 
      return;
    }

    window.addEventListener("message", this.iframeMessageListener, false);
    const link = await linksGenerator();
    setTimeout(() => window.parent.postMessage("Creator_RDY", link.b2b), 1000);
  };

  readyRender = () => (
    //router displays proper pages depending on url
    <Router>
      <React.Fragment>
        <MobileNotAvailableWarning
          lang={this.state.lang}
          langChangeHandler={this.onLangChange}
        />
        <div className="container">
          <CurrentSvgSprite
            iconStyle={this.state.colorSettings.iconStyle}
            cartIconStyle={this.state.colorSettings.cartIconStyle}
            colorSettings={this.state.colorSettings}
            spinnerIconStyle={this.state.colorSettings.spinnerIconStyle}
          />
          {this.iframeRender()}

          <Options
            ref={this.optionsRef}
            changeConfig={changeConfig.bind(this)}
            changeNameAndConfigForRecommended={changeNameAndConfigForRecommended.bind(this)}
            updateTemplateSettings={this.updateTemplateSettings}
            elementInOptions={this.state.elementInOptions}
            areOptionsOpen={this.state.areOptionsOpen}
            closeOptions={this.handleOptionsClose}
            closeOptionsWithRestore={this.handleOptionsCloseWithRestore}
            pushNotification={this.pushNotification}
            updateChangesOption={this.updateChangesOption}
          />

          <NotificationContainer ref={this.notifications} />

          <Routes>
            {this.getPages() /*add all possible routes*/}
          </Routes>
        </div>
      </React.Fragment>
    </Router>
  );

  iframeRender = () => {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    
    if (this.state.timeoutError) {
      return <div>Error, comm timeout</div>;
    }
    
    if (this.state.invalidOrigin) {
      return <div>Error, invalid message origin</div>;
    }
    
    if (this.state.xml) {
      return (
        <ImportXmlPromptModal
          onImportClick={() => this.loadTemplateXml()}
          onContinueClick={this.rejectXmlImport}
        />
      );
    }
    
    return this.getModals();
  };

  render() {
    //this shouldn't be called here (mutates the object before rendering)
    checkAllRequiredElements.call(this);
    return this.readyRender();
  }
}


export default App;
